/* import __COLOCATED_TEMPLATE__ from './reviewable-post.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-post.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));